import { leagueFetch } from '@leagueplatform/league-fetch';
import { HealthMetricPostData } from './post-health-metrics';

export type HealthMetricPatchData = HealthMetricPostData & {
  observationId: string;
};

// TODO: Will be used once the backend is ready.
// export async function updateHealthMetricsBatch(data: HealthMetricPatchData[]) {
//   const response = await leagueFetch(`v3/health-metrics-batch`, {
//     method: 'PATCH',
//     body: JSON.stringify({
//       data: {
//         type: 'health-metrics-batch',
//         attributes: {
//           entries: data.map(({ observationId, ...datum }) => ({
//             id: observationId,
//             ...datum,
//           })),
//         },
//       },
//     }),
//   });
//
//   if (!response.ok) {
//     throw new Error(`PatchCreateHealthMetrics error: ${response.status}`);
//   }
// }

async function updateHealthMetricsLegacy(data: HealthMetricPatchData[]) {
  const requests = data.map(async (datum) => {
    const { observationId, ...metric } = datum;
    const response = await leagueFetch(
      `v3/health-metrics/${datum.observationId}`,
      {
        method: 'PATCH',
        body: JSON.stringify({
          data: {
            type: 'health-metric',
            id: observationId,
            attributes: metric,
          },
        }),
      },
    );
    if (!response.ok) {
      throw new Error(`PatchCreateHealthMetrics error: ${response.status}`);
    }
    return response;
  });

  await Promise.all(requests);
}

export const updateHealthMetrics = updateHealthMetricsLegacy;
